import { UIActionType, UIAction } from '../../actions/uiActions';

const selectedProcessIdReducer = (state = '', action: UIAction) => {
  if (action.type === UIActionType.SET_SELECTED_RUNTIME_ID) return action.id;
  return state;
};

export default selectedProcessIdReducer;
